import React, { forwardRef, useState, useEffect } from 'react';
import { ProductImage } from 'anf-core-react';

const MobileImageSliderHero = forwardRef(({
  productImages,
  activeIndex,
  onImageClick,
  onImageError,
  onImageLoad,
  onTouchEnd,
  onScroll,
  setAltText,
}, ref) => {
  const [loadedImages, setLoadedImages] = useState(new Set());

  useEffect(() => {
    setLoadedImages(new Set());
  }, [productImages]);

  const handleImageLoad = (imageId) => {
    setLoadedImages((prev) => new Set([...prev, imageId]));
    onImageLoad?.();
  };

  const handleImageError = (imageId) => {
    setLoadedImages((prev) => new Set([...prev, imageId]));
    onImageError?.(imageId);
  };

  return (
    <section className="mobile-image-slider-with-thumbnails">
      <div className="main-slider-container">
        <div
          className="main-image-slider"
          ref={ref}
          data-testid="product-carousel-mobile"
          role="listbox"
          aria-label="Product images"
          aria-live="polite"
          aria-atomic="true"
          tabIndex="0"
          onScroll={onScroll}
        >
          {productImages.map((imageDetails, index) => {
            const isLoaded = loadedImages.has(imageDetails?.imageId);
            return (
              <div
                className="mobile-image-wrapper"
                key={`main-${imageDetails?.imageId || index}`}
                onTouchEnd={onTouchEnd}
                role="option"
                aria-label={setAltText?.(index, imageDetails?.type || 'product')}
                aria-selected={index === activeIndex}
                aria-posinset={index + 1}
                aria-setsize={productImages.length}
                tabIndex={index === activeIndex ? 0 : -1}
                id={`main-image-${index}`}
                data-loaded={isLoaded}
              >
                <div className="mobile-image-wrapper__loading-placeholder" />
                <ProductImage
                  alt={setAltText?.(index, imageDetails?.type || 'product')}
                  data-testid="product-image"
                  classList="product-image-react mobile-image-wrapper__image"
                  src={imageDetails?.mainImageSrc}
                  onError={() => handleImageError(imageDetails?.imageId)}
                  onClick={(event) => onImageClick?.(event, imageDetails)}
                  onLoad={() => handleImageLoad(imageDetails?.imageId)}
                  data-size=""
                />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
});

MobileImageSliderHero.displayName = 'MobileImageSliderHero';

export default MobileImageSliderHero;
